import { IGetObraChecklistServicoHeaderUseCase } from "../../../presentation/useCases/read/get_obra_checklist_servico_header_use_case";
import { ObraChecklistServicoHeader } from "../../models/obra_checklist_servico_header";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraChecklistServicoHeaderUseCase
 */

export class GetObraChecklistServicoHeaderUseCase implements IGetObraChecklistServicoHeaderUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraChecklistServicoHeader(
    idObraChecklistServico: number | undefined,
  ): Promise<ObraChecklistServicoHeader> {
    if (idObraChecklistServico === undefined) throw new Error('Falha ao obter id de checklist de serviço!');
    return await this.repository.getObraChecklistServicoHeader(
      idObraChecklistServico,
    );
  }
}
